@if(_selectedDischarge){
<div class="row">
  <div class="col-md-6">
    <div>
      <div class="card shadow-sm ">
        <div class="card-header with-border">
          Discharge
        </div>
        <div class="card-body">
          <div>
          <form #discharge="ngForm" class="form-horizontal">
            <fieldset class=" border-0"
              [disabled]="!hasRole('vessels-voyages-editor')">
              <div class="form-group row">
                <div class="col-md-6">
                  <app-material-date-range
                    id="selectedDate"
                    [singleDateSelector]="true"
                    [(dateRange)]="dischargeDate"
                    required
                    [disabled]="edit"
                    [localeDateFormat]="'YYYY-MM-DD'">
                  </app-material-date-range>
                </div>
                <div class="col-md-6">
                  <app-material-organisation-selector
                    class="pg-component"
                    [(ngModel)]="port"
                    [organisationLanguage]="'en'"
                    name="port2"
                    id="port2"
                    [disabled]="edit"
                    [placeholder]="'Port'"
                    (ngModelChange)="dischargeLocation($event)"
                    [organisations]="portOrganisations"
                    [required]="true">
                  </app-material-organisation-selector>
                </div>
              </div>
              <div class="form-group row">
                <app-material-chunk-file-uploader
                  [accept]="'.pdf'"
                  name="document"
                  [ngModel]="doc"
                  (ngModelChange)="uploadDocument($event)">
                </app-material-chunk-file-uploader>
              </div>
              @if (!isSts) {
                <div class="form-group row">
                  <div class="col-md-12">
                    <app-material-organisation-selector
                      class="pg-component"
                      [(ngModel)]="consignee"
                      [organisationLanguage]="'en'"
                      id="consignee"
                      name="consignee"
                      [placeholder]="'Consignee'"
                      [organisations]="consignees"
                      [required]="true">
                    </app-material-organisation-selector>
                  </div>
                </div>
              }
              @if (isSts) {
                <div>
                  <div class="form-group row">
                    <div class="col-md-12">
                      <app-material-auto-complete
                        name="daughterVessel"
                        id="daughterVessel"
                        [formatter]="vesselFormatter"
                        [(ngModel)]="daughterVessel"
                        (ngModelChange)="getDaughterVesselVoyages($event)"
                        [items]="vessels"
                        [placeholder]="'Daughter Vessel'"
                        [disabled]="edit"
                        [required]="true">
                      </app-material-auto-complete>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12">
                        <app-material-auto-complete
                          class="w-100"
                          name="voyageNo"
                          [placeholder]="'Voyage NO'"
                          id="voyageNo"
                          [items]="daughterVesselVoyages"
                          [formatter]="voyageFormatter"
                          [(ngModel)]="daughterVesselVoyage"
                          
                          [required]="true">
                        </app-material-auto-complete>
                    </div>
                  </div>
                </div>
              }
              @if (showMeasurement) {
                <div class="row">
                  <form #measurements="ngForm">
                    <div class="d-flex flex-row align-items-end" style="gap: 15px;">
                      @if (tempMeasurement.provider ==='Surveyor' || tempMeasurement.provider ==='Surveyor Loading') {
                        <app-material-organisation-selector
                          id="surveyor"
                          [(ngModel)]="surveyor"
                          [organisationLanguage]="'en'"
                          name="surveyors"
                          [placeholder]="'Surveyor'"
                          [organisations]="surveyors"
                          [required]="true">
                        </app-material-organisation-selector>
                      }
                        <app-material-auto-complete
                          class="flex-grow-1"
                          name="product"
                          id="product"
                          [(ngModel)]="tempMeasurement.product"
                          (ngModelChange)="getDaughterVesselVoyages($event)"
                          [required]="true"
                          [placeholder]="'Select Product'"
                          [items]="productNames"
                          [formatter]="productFormatter">
                        </app-material-auto-complete>
                      <app-material-pg-input
                        style="width:130px;"
                        type="number"
                        name="weight"
                        id="weight"
                        label="Weight"
                        [(ngModel)]="tempMeasurement.weight"
                        [required]="true">
                      </app-material-pg-input>
                      <mat-checkbox
                        id="primary"
                        name="primary"
                        [(ngModel)]="tempMeasurement.primary"
                        class="pb-2"> Primary
                      </mat-checkbox>
                    </div>
                    <div class="btn-group pull-right mt-2" role="group">
                      <app-material-pg-button
                        class="me-1"
                        id="cancel"
                        (clicked)="showMeasurement = false"
                        label="Cancel">
                      </app-material-pg-button>
                      <app-material-pg-button
                        label="Add"
                        id="save"
                        [disabled]="!measurements.form.valid"
                        (clicked)="addToMeasurements()">
                      </app-material-pg-button>
                    </div>
                  </form>
                </div>
              }
              @if (showBillOfLading) {
                <div class="row">
                  <form #billOfLading="ngForm">
                      <app-material-auto-complete
                        class="col-md-12"
                        name="temporaryBillOfLadingSelection"
                        [placeholder]="'Bill Of Lading'"
                        [(ngModel)]="tempBillOfLading"
                        [items]="availableBillOfLadingsToAssign"
                        [formatter]="billOfLadingFormatter">
                      </app-material-auto-complete>
                    <div class="btn-group pull-right mt-2" role="group">
                      <app-material-pg-button
                        class="me-1"
                        id="cancel"
                        (clicked)="showBillOfLading = false"
                        label="Cancel">
                      </app-material-pg-button>
                      <app-material-pg-button
                        label="Add"
                        id="save"
                        [disabled]="!billOfLading.form.valid"
                        (clicked)="addToBillOfLading()">
                      </app-material-pg-button>
                    </div>
                  </form>
                </div>
              }
              <div class="row mt-3">
                <div class="col-md-12">
                  <div class="card-header">
                    <h3 class="card-title fw-bold">Measurements</h3>
                  </div>
                  <table
                    class="table table-sm table-striped table-bordered text-center w-100 mt-2">
                    <thead>
                      <tr>
                        @if (_selectedDischarge.measurements.length > 1) {
                          <th
                          ></th>
                        }
                        <th>Provider type</th>
                        <th>Provider</th>
                        <th>Product</th>
                        <th>Weight</th>
                        <th>Primary</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (measurement of measurements; let i=$index; track $index) {
                        <tr>
                          @if (_selectedDischarge.measurements.length > 1) {
                            <td
                              >
                              <ng-container>
                                <a (click)="removeMeasurement(i)">
                                  <i class="fa fa-trash"></i>
                                </a>
                              </ng-container>
                            </td>
                          }
                          <td>{{measurement.provider}}</td>
                          <td>{{providerFormatter(measurement)}}</td>
                          <td>{{measurement.product}}</td>
                          <td>{{measurement.weight}}</td>
                          <td>@if (measurement.primary) {
                            <i class="fa fa-check"></i>
                          }</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row mt-5">
                <div class="col-md-12">
                  <div class="card-header">
                    <h3 class="card-title fw-bold">Bill Of Ladings</h3>
                  </div>
                  <table class="table table-striped table-bordered w-100 mt-2">
                    <thead>
                      <tr>
                        <th></th>
                        <th>No</th>
                        <th>Product</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (bl of assignedBillOfLadings ; let i=$index; track $index) {
                        <tr>
                          @if (hasRole('vessels-voyages-editor')) {
                            <td
                              >
                              <ng-container>
                                <a (click)="removeAssignedBL(i)">
                                  <i class="fa fa-trash"></i>
                                </a>
                              </ng-container>
                            </td>
                          }
                          <td>
                            @if (bl) {
                              {{bl.no}}
                            }
                          </td>
                          <td>
                            @if (bl) {
                              @for (p of bl.products; track $index) {
                                {{p.product}}: {{p.grossWeight | number}} <br>
                              }
                            }
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </fieldset>
            <div class="d-flex justify-content-end mt-3" role="group"
              aria-label="Button group with nested dropdown">
              @if (hasRole('vessels-voyages-editor')) {
                <ng-container class="btn-group " role="group"
                  >
                  <div class="btn-group me-1" role="group">
                    <app-material-pg-button
                      class="me-1"
                      label="Add"
                      id="addButtonGroup"
                      data-bs-toggle="dropdown"
                      aria-expanded="false">
                    </app-material-pg-button>
                      <app-material-pg-button
                      id="cancel"
                      (clicked)="backToVoyage()"
                      label="Back to voyage">
                    </app-material-pg-button>
                    <div class="dropdown-menu" aria-labelledby="addButtonGroup">
                      @if (isSts) {
                        <a class="dropdown-item"
                          (click)="addNewMeasurement('Mother Vessel Figure')"
                        >Mother Vessel Figure</a>
                      }
                      @if (isSts) {
                        <a class="dropdown-item"
                          (click)="addNewMeasurement('Daughter Vessel Figure')"
                        >Daughter Vessel Figure</a>
                      }
                      <a class="dropdown-item"
                        (click)="addNewMeasurement('Surveyor')">Surveyor Figure Discharge
                      Density</a>
                      <a class="dropdown-item"
                        (click)="addNewMeasurement('Surveyor Loading')">Surveyor Figure
                      Loading Density</a>
                      <a class="dropdown-item" (click)="addBl()">Bill of lading</a>
                    </div>
                  </div>
                </ng-container>
              }
              @if (edit && hasRole('vessels-voyages-editor')) {
                <app-material-pg-button
                  class="me-1"
                  id="delete"
                  (clicked)="deleteDischarge()"
                  label="Delete">
                </app-material-pg-button>
              }
              @if (hasRole('vessels-voyages-editor')) {
                <app-material-pg-button
                  id="submit"
                  (clicked)="saveDischarge()"
                  [disabled]="!discharge.form.valid"
                  label="Save">
                </app-material-pg-button>
              }
            </div>
          </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div>
      <app-material-pdf-viewer [fileId]="_selectedDischarge.fileId"> </app-material-pdf-viewer>
    </div>
  </div>
</div>
}
